import React from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import { FaHome, FaEnvelope, FaWhatsapp, FaCompass } from "react-icons/fa";

const QUICK_LINKS = [
  { to: "/services", label: "Our Services" },
  { to: "/about", label: "About Us" },
  { to: "/testimonials", label: "Testimonials" },
  { to: "/contact", label: "Contact Us" },
];

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-6 py-24 text-center">
      <Helmet>
        <title>Page Not Found | Lumis Documents Clearing Dubai</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>

      {/* Animated compass icon */}
      <div className="relative mb-8">
        <div className="w-28 h-28 bg-blue-600 rounded-full flex items-center justify-center shadow-2xl mx-auto animate-pulse">
          <FaCompass className="text-white text-5xl" />
        </div>
        <span className="absolute -top-2 -right-2 bg-red-500 text-white text-xs font-bold px-2.5 py-1 rounded-full shadow">
          404
        </span>
      </div>

      {/* Headline */}
      <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4">
        Page Not Found
      </h1>
      <p className="text-gray-500 text-lg max-w-md mx-auto mb-10 leading-relaxed">
        Looks like this page has gone missing. It may have been moved, deleted,
        or perhaps the URL was typed incorrectly.
      </p>

      {/* Primary CTA */}
      <div className="flex flex-wrap justify-center gap-4 mb-14">
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-8 py-3.5 rounded-full shadow-md transition"
        >
          <FaHome /> Back to Home
        </Link>
        <a
          href="https://wa.me/971547662665"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-green-500 hover:bg-green-600 text-white font-semibold px-8 py-3.5 rounded-full shadow-md transition"
        >
          <FaWhatsapp /> WhatsApp Us
        </a>
      </div>

      {/* Quick links */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 px-8 py-6 max-w-sm w-full">
        <p className="text-sm font-semibold text-gray-400 uppercase tracking-wider mb-4">
          You might be looking for
        </p>
        <ul className="space-y-2">
          {QUICK_LINKS.map(({ to, label }) => (
            <li key={to}>
              <Link
                to={to}
                className="block text-sm text-gray-700 hover:text-blue-600 hover:bg-blue-50 px-3 py-2 rounded-lg transition font-medium"
              >
                → {label}
              </Link>
            </li>
          ))}
        </ul>
      </div>

      {/* Contact nudge */}
      <p className="text-sm text-gray-400 mt-10">
        Still lost?{" "}
        <Link
          to="/contact"
          className="text-blue-600 font-semibold hover:underline inline-flex items-center gap-1"
        >
          <FaEnvelope /> Contact our team
        </Link>
      </p>
    </div>
  );
}
